import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from './messages';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useEntitiesSalesOrder } from '../../../../hooks/entities/selectors/sales-orders';
import GetMarketplaceDisplayName from '../../../../components/data-driven-logo/get-marketplace-display-name';

import style from './order-summary.module.less';

const InformationBanner = () => {
  const intl = useIntl();
  const salesOrderId = useSalesOrderIdContext();
  const salesOrder = useEntitiesSalesOrder(salesOrderId) ?? {};
  const { marketplaceId } = salesOrder.store ?? {};

  const marketplaceNameTranslation = GetMarketplaceDisplayName(marketplaceId);
  const marketplaceName = intl.formatMessage(marketplaceNameTranslation, marketplaceNameTranslation.values);

  return (
    <div className={style['information-banner']}>
      <FormattedMessage
        {...messages.informationBanner}
        values={{
          marketplaceName,
        }}
      />
    </div>
  );
};

export default InformationBanner;
